module.exports = __webpack_public_path__ + "media/img/decorations/info-img-bg-0034664087e4e9590d7ec0a5421db556.svg";